import { FC, useCallback, useEffect, useState } from 'react';
import { Form } from '@brg/api';
import { useToasts } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { LayoutConst, useModal } from 'core';
import urlApi from 'shared/actions/urlApi';
import { PageViewportLayout } from 'shared/components/template';
import { LoaderSpinner } from 'shared/modals/artzLegalsModal/LoaderAnimation';
import { TabPanel } from 'shared/pages/teams/components/Panel/TabPanel';
import { TeamFormsEdit } from 'shared/pages/teams/components/TeamFormsEdit';
import { TeamAdminEditType } from 'shared/pages/teams/types/types';

const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    max-width: calc(100vw - 32px);
    margin: 40px auto 0;
    position: relative;
    overflow-y: auto;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        max-width: 100%;
        margin: 16px auto 0;
        padding: 0 16px 24px;
    }
`;

const LoaderWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 240px;
    width: 100%;
`;

export type TeamFormModalProps = {
    form?: Form | any;
    formId?: string;
    editType?: TeamAdminEditType;
    onUpdate?: (val: any) => void;
};

export const TeamFormModal: FC<TeamFormModalProps> = ({
    form: formProp,
    formId,
    editType,
    onUpdate,
}) => {
    const modal = useModal();
    const toasts = useToasts();
    const { t } = useTranslation();
    const [form, setForm] = useState<any>(formProp ?? null);
    const [isLoading, setIsLoading] = useState(!formProp && !!formId);
    const [isChangesSaved, setIsChangesSaved] = useState(false);
    const [isFormFieldsFilled, setIsFormFieldsFilled] = useState(false);

    useEffect(() => {
        if (formProp) {
            setForm(formProp);
            setIsLoading(false);
            return;
        }

        const id = formId || formProp?.formId;
        if (!id) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        urlApi()
            .getForm(id)
            .then((response) => response.json())
            .then((data) => {
                if (!cancelled) {
                    setForm(data);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    toasts.error(t('teams.adminPage.servicesTabs.shopApplicationFormLoadError'));
                    modal.hide();
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [formProp, formId]);

    const handleClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    const handleSubmit = useCallback(() => {
        toasts.info(t('teams.admin.msg.save'));
        setIsChangesSaved(true);
    }, [t, toasts]);

    const handleUpdate = useCallback((val: any) => {
        onUpdate?.(val);
    }, [onUpdate]);

    if (isLoading) {
        return (
            <ModalContainer>
                <LoaderWrap>
                    <LoaderSpinner />
                </LoaderWrap>
            </ModalContainer>
        );
    }

    if (!form) {
        return null;
    }

    return (
        <ModalContainer>
            <PageViewportLayout offsetTop={0}>
                <TabPanel
                    text={t('panel.teams.forms_title')}
                    disabled={!isFormFieldsFilled}
                    onSubmit={handleSubmit}
                    onExit={handleClose}
                />
                <TeamFormsEdit
                    form={form}
                    editType={editType}
                    isChangesSaved={isChangesSaved}
                    setIsChangesSaved={setIsChangesSaved}
                    setIsFormFieldsFilled={setIsFormFieldsFilled}
                    onUpdate={handleUpdate}
                    onStatusSet={() => undefined}
                    onClose={handleClose}
                />
            </PageViewportLayout>
        </ModalContainer>
    );
};
import { FC, useCallback, useEffect, useState } from 'react';
import { Form } from '@brg/api';
import { useToasts } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { LayoutConst, useModal } from 'core';
import urlApi from 'shared/actions/urlApi';
import { PageViewportLayout } from 'shared/components/template';
import { LoaderSpinner } from 'shared/modals/artzLegalsModal/LoaderAnimation';
import { TabPanel } from 'shared/pages/teams/components/Panel/TabPanel';
import { TeamFormsEdit } from 'shared/pages/teams/components/TeamFormsEdit';
import { TeamAdminEditType } from 'shared/pages/teams/types/types';

const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    max-width: calc(100vw - 32px);
    margin: 40px auto 0;
    position: relative;
    overflow-y: auto;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        max-width: 100%;
        margin: 16px auto 0;
        padding: 0 16px 24px;
    }
`;

const LoaderWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 240px;
    width: 100%;
`;

export type TeamFormModalProps = {
    form?: Form | any;
    formId?: string;
    editType?: TeamAdminEditType;
    onUpdate?: (val: any) => void;
};

export const TeamFormModal: FC<TeamFormModalProps> = ({
    form: formProp,
    formId,
    editType,
    onUpdate,
}) => {
    const modal = useModal();
    const toasts = useToasts();
    const { t } = useTranslation();
    const [form, setForm] = useState<any>(formProp ?? null);
    const [isLoading, setIsLoading] = useState(!formProp && !!formId);
    const [isChangesSaved, setIsChangesSaved] = useState(false);
    const [isFormFieldsFilled, setIsFormFieldsFilled] = useState(false);

    useEffect(() => {
        if (formProp) {
            setForm(formProp);
            setIsLoading(false);
            return;
        }

        const id = formId || formProp?.formId;
        if (!id) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        urlApi()
            .getForm(id)
            .then((response) => response.json())
            .then((data) => {
                if (!cancelled) {
                    setForm(data);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    toasts.error(t('teams.adminPage.servicesTabs.shopApplicationFormLoadError'));
                    modal.hide();
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [formProp, formId]);

    const handleClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    const handleSubmit = useCallback(() => {
        toasts.info(t('teams.admin.msg.save'));
        setIsChangesSaved(true);
    }, [t, toasts]);

    const handleUpdate = useCallback((val: any) => {
        onUpdate?.(val);
    }, [onUpdate]);

    if (isLoading) {
        return (
            <ModalContainer>
                <LoaderWrap>
                    <LoaderSpinner />
                </LoaderWrap>
            </ModalContainer>
        );
    }

    if (!form) {
        return null;
    }

    return (
        <ModalContainer>
            <PageViewportLayout offsetTop={0}>
                <TabPanel
                    text={t('panel.teams.forms_title')}
                    disabled={!isFormFieldsFilled}
                    onSubmit={handleSubmit}
                    onExit={handleClose}
                />
                <TeamFormsEdit
                    form={form}
                    editType={editType}
                    isChangesSaved={isChangesSaved}
                    setIsChangesSaved={setIsChangesSaved}
                    setIsFormFieldsFilled={setIsFormFieldsFilled}
                    onUpdate={handleUpdate}
                    onStatusSet={() => undefined}
                    onClose={handleClose}
                />
            </PageViewportLayout>
        </ModalContainer>
    );
};
